/**
 * List of Colombian tax regimes.
 * @type {{id: string, name: string}[]}
 */
export default [
  { id: 'taxable', name: 'Gravado' },
  { id: 'non_taxable', name: 'No gravado' }
]
